import React, { useEffect, useState, useContext } from "react";
import { useRouter } from "next/router";
import Image from "next/image";
import Link from "next/link";
import clsx from "clsx";
import { Container, Box, Typography, Drawer } from "@mui/material";
import { makeStyles } from "@mui/styles";
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import useWindowSize from "utils/useWindowSize";
import { X, Menu as MenuIcon } from "react-feather";
import LogoFull from "public/logow.jpg";
import LogoFullEng from "public/logow.jpg";
import { getPageList } from "context/actions/pages";

const HeaderHeight = 80;

const useStyles = makeStyles((theme) => ({
  root: {
    height: HeaderHeight,
    backgroundColor: "#005693",
    zIndex: 99,
    position: "fixed",
    top: 0,
  },
  drawerPaper: {
    minWidth: 300,
    paddingLeft: 24,
    paddingRight: 24,
    overflowX: "hidden",
    paddingBottom: 40,
  },
  drawerInnerBox: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  animatedDrawerInnerBox: {
    animation: `$drawerLoadIn 400ms ${theme.transitions.easing.easeOut}`,
    animationDelay: "350ms",
    animationFillMode: "forwards",
    opacity: 0,
  },
  "@keyframes drawerLoadIn": {
    "0%": {
      opacity: 0.4,
      transform: "translateX(100px)",
    },
    "100%": {
      opacity: 1,
      transform: "translateX(0)",
    },
  },
  "@keyframes footerLoadIn": {
    "0%": {
      opacity: 0.4,
      transform: "translateY(100px)",
    },
    "100%": {
      opacity: 1,
      transform: "translateX(0)",
    },
  },
}));

const Header = () => {
  const classes = useStyles();
  const { sizes } = useWindowSize();
  const router = useRouter();
  const [scrollTop, setScrollTop] = useState(0);
  const [showMenu, setShowMenu] = useState(false);
  const [menus, setMenus] = useState([]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollTop(position);
  };

  useEffect(() => {
    getMenus();
  }, []);

  const getMenus = async () => {
    const datas = await getPageList(true);

    if (datas.status === "success") {
      setMenus(datas.data);
    }
  };

  const handleMenuButtonClick = () => {
    setShowMenu((prev) => !prev);
  };

  const handleDrawerClose = () => {
    setShowMenu(false);
  };

  const handleRoteClick = (menu) => {
    showMenu && handleDrawerClose();

    if ((menu.url && menu.url.charAt(0) === "/") || !menu.url)
      router.push(menu.url ? "/" + menu.url : "/content/" + menu.id);
    else {
      const newWindow = window.open(menu.url, "_blank", "noopener,noreferrer");
      if (newWindow) newWindow.opener = null;
    }
  };

  const RenderMenu = ({ menu, showsMenu = true, type = "header" }) => {
    return (
      <div style={{ position: "relative" }}>
        <li
          className={`relative flex items-center justify-start cursor-pointer text-white font-bold capitalize text-[15px] px-[22px] py-[15px] ${
            type === "drawer" ? "h-[30px]" : "h-[80px]"
          }`}
        >
          <Link
            href={menu.url ? menu.url : "/content/" + menu.id}
            passHref
            target={
              (menu.url && menu.url.charAt(0) === "/") || !menu.url
                ? "_self"
                : "_blank"
            }
          >
            {i18n.language === "mn" ? menu.name : menu.nameEng}
          </Link>
        </li>
      </div>
    );
  };

  const RenderToggleMenu = ({ menu, showsMenu = true, type = "header" }) => {
    return (
      <div>
        <li
          className={`relative flex items-center justify-start px-2.5 cursor-pointer font-bold text-[14px] ${
            type === "drawer" ? "h-[30px] text-white" : "h-[80px] text-white"
          }`}
        >
          <Typography
            variant={"h4"}
            className="text-[#210455] font-bold cursor-pointer mr-[46px] h-fit hover:text-[#a19d9d]"
            onClick={() => handleRoteClick(menu)}
          >
            {i18n.language === "mn" ? menu.name : menu.nameEng}
          </Typography>
        </li>
      </div>
    );
  };

  return (
    <>
      <Container
        maxWidth={false}
        disableGutters={true}
        className={classes.root}
        style={{
          position: scrollTop > 0 ? "fixed" : "absolute",
          top: scrollTop > 0 ? 0 : 0,
        }}
      >
        <Container
          maxWidth={"lg"}
          className="h-full flex items-center"
        >
          <Link href={"/"} passHref>
            <Box style={{ display: "flex", alignItems: "center" }}>
              <Image
                width={sizes.sm ? 60 : 60}
                src={i18n.language === "mn" ? LogoFull : LogoFullEng}
                alt=""
                objectFit={"cover"}
                style={{ borderRadius: 100 }}
              />
              <Box className="flex">
                <Typography className="font-bold text-white text-[30px] leading-[1.167] ml-[15px] tracking-[-0.24px] font-roboto">
                Mandal CARGO
                </Typography>
              </Box>
            </Box>
          </Link>
          {!sizes.sm ? (
            <>
              <Box className="h-full ml-auto flex items-center w-fit">
                <ul className="relative flex flex-row">
                  {menus.map((m, ind) => {
                    return <RenderMenu key={ind} position={ind} menu={m} />;
                  })}
                </ul>
              </Box>
            </>
          ) : (
            <>
              <MenuIcon
                color={"#035dab"}
                className="text-white ml-auto w-10 h-10 cursor-pointer"
                size={"14"}
                onClick={handleMenuButtonClick}
              />
              <Drawer
                anchor="right"
                classes={{ paper: classes.drawerPaper }}
                onClose={handleDrawerClose}
                open={showMenu}
                transitionDuration={{
                  enter: 500,
                  exit: 500,
                }}
                variant="temporary"
              >
                <Box
                  className={clsx({
                    [classes.drawerInnerBox]: true,
                    [classes.animatedDrawerInnerBox]: showMenu,
                  })}
                >
                  <X
                    color={"#210455"}
                    className="text-white mt-5 mb-1.5 ml-auto w-9 h-9 cursor-pointer min-h-[40px]"
                    size={"18"}
                    onClick={handleDrawerClose}
                  />

                  {menus.map((m, ind) => {
                    return (
                      <RenderToggleMenu key={ind} menu={m} type="drawer" />
                    );
                  })}
                </Box>
              </Drawer>
            </>
          )}
        </Container>
      </Container>
    </>
  );
};

export default Header;
